import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=66ccce5b&scoped=true"
import script from "./bottomNav.vue?vue&type=script&lang=js"
export * from "./bottomNav.vue?vue&type=script&lang=js"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=66ccce5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ccce5b",
  null
  
)

export default component.exports